import {get} from './request'

import { storage } from '../../utils/tools'
import { serverApiUrl } from '../config/server';

export default async ()=>{
    const res = await get(`${serverApiUrl}/user/myinfo`);
    let data = res.data;
    if (data.success) {
        let userinfo = data.data;
        storage.set('userinfo', userinfo);
        return userinfo;
    } else {
        return null;
    }
}